/* eslint-disable no-template-curly-in-string */
<template>
  <el-drawer :visible.sync="drawer" :with-header="false" size="1088px">
    <div class="join-inquiry-list-drawer">
      <div>
        <i class="el-icon-close" style="font-size:22px" @click="onClose"></i>
      </div>
      <div class="join-inquier-list-product">
        <div class="join-inquier-list-product-title leftBorder">
          <span>模版名称</span>
        </div>
        <el-form label-width="120px" class="demo-ruleForm">
          <el-row>
            <el-col :span="20">
              <el-form-item prop="templateName" label="模板名称：">
                <el-input
                  v-model="queryParams.templateName"
                  :disabled="isdisable"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="产品列表形式列：">
                <el-col style="padding:0px;">
                  <el-select
                    v-model="queryParams.type"
                    :disabled="isdisable"
                    @change="handlechange"
                    @remove-tag="removehandle"
                    multiple
                    value-key="key"
                  >
                    <el-option
                      :label="v.label"
                      :value="v"
                      v-for="(v,index) in  listItemS"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <span class="postfix_show">可选择产品列表展示项,默认展示全部</span>
            </el-col>
          </el-row>

          <div class="parent-node">
            <eitContents
              v-model="editorData"
              :update="isRandomEnable"
              @getCkeditor="getCkeditor"
              ref="editors"
            ></eitContents>
            <div :class="isshowThree?'children-filter':'not_child-filter'">
              <el-row :gutter="24">
                <el-col :span="isshowThree?6:8">
                  <el-select
                    v-model="valueOne"
                    :placeholder="placeolder"
                    @visible-change="visableChange"
                    class="select_input"
                    @change="handleChangeReplate"
                  >
                    <el-option
                      v-for="(item,index) in supplier"
                      :key="index"
                      :label="item.fname"
                      :value="item.wildCard"
                    ></el-option>
                  </el-select>
                </el-col>

                <el-col :span="isshowThree?6:8">
                  <el-select
                    v-model="valueTwo"
                    @visible-change="twovisableChange"
                    :placeholder="placeolderTwo"
                    class="select_input"
                    @change="offerhandler"
                  >
                    <el-option
                      v-for="(item,index) in contractoptions"
                      :key="index"
                      :label="item.fname"
                      :value="item.wildCard"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="isshowThree?6:8">
                  <el-select
                    v-model="valueThree"
                    @visible-change="threevisableChange"
                    :placeholder="placeholderThree"
                    @change="handelerouper"
                    class="select_input"
                    v-if="isshowThree"
                  >
                    <el-option
                      v-for="(item,index) in offerlist"
                      :key="index"
                      :label="item.fname"
                      :value="item.wildCard"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div class="footbat">
        <el-button type="primary" :disabled="isdisable" @click="tosave">保存</el-button>
        <el-button @click="toreset" :disabled="isdisable">重置</el-button>
        <el-button @click="tocancle" :disabled="isdisable">取消</el-button>
      </div>
    </div>
    <!-- <eitContents v-model="content"></eitContents> -->
  </el-drawer>
</template>
<script>
  import eitContents from '@/components/eidorClass/index'
  import {proAllContent} from '../utils/data'
  // updateInfo
  import {
    replateStr,
    seltOne,
    selectSumTemplate,
    SelectwoTableContent
  } from '@/util/static'

  import {FileTemplate} from '@/api/system/rightsManagement'

  export default {
    components: {
      eitContents
    },
    data() {
      return {
        isdeleteSum: false,
        CKEDITOR_4: null,
        isfutures: false,
        isdelteId: false,
        showTwoTable: [], // 这是单西方数据页面
        isshowTwoTable: 0, // 是否展示二级数据
        showtable: 1,
        isEnd: 0,
        isdisable: false,
        templateId: '',
        // editor: ClassicEditor,
        editorData: '',
        editorConfig: {},
        content: '',
        recordJoinarr: [], // 合集
        // editor: null,
        // 所谓的数据操作
        tableData: [],
        // ...getALl,
        isshowThree: false,
        placeolder: '',
        placeolderTwo: '',
        placeholderThree: '',
        valueOne: '',
        valueTwo: '',
        valueThree: '',
        itemCurrItem: '',
        ckeditor_template: null,

        // tableData:[],
        tableDatas: [
          {
            key: 'sum',
            label: '总价'
          },
          {
            key: 'sum',
            label: '总价'
          }
        ],
        // 总计
        listarr: [
          {
            id: 1,
            whole: 10
          },
          {
            id: 1,
            whole: 10
          },
          {
            id: 1,
            whole: 10
          },
          {
            id: 1,
            whole: 10
          }
        ],
        isRandomEnable: 0,
        oldtempValue: '',
        isFuterData: {},
        listItemItem: [],
        listItemS: [],
        placeoldThree: '',
        offerlist: [],
        contractoptions: [],
        supplier: [],
        value: '',
        // content: '',
        editorOption: {
          placeholder: '编辑文章内容'
        },
        drawer: false,
        arrList: {},
        isckedit: null,
        isSelected: false,
        queryParams: {
          templateName: '',
          type: []
        },
        // _selfis: null,
        // bufferTmp:[],
        proAllContent: proAllContent
      }
    },
    mounted() {
      // editors
    },
    watch: {
      editorData: function (newVal, oldVal) {
        return newVal
      },
      drawer: function (newVal, oldCak) {
        if (!newVal) {
          // this.isckedit.destroy()
          this.$nextTick(function () {
            this.$parent.getInit()
          })
        }
      }
    },
    methods: {
      //这是利用他本身的方法来设置指定光标内插入以及数据方法
      setDataValuehtml(value) {
        if (this.CKEDITOR_4 !== null) {
          this.CKEDITOR_4.focus()
          // 将光标移至最末
          var range = this.CKEDITOR_4.createRange()
          range.moveToElementEditEnd(this.CKEDITOR_4.editable())
          range.select()
          range.scrollIntoView()
          var _self = this
          // setTimeout(function() {
          _self.CKEDITOR_4.insertHtml(value)
          // }, 5000)
        }
      },
      getCkeditor(ckeditor) {
        this.CKEDITOR_4 = ckeditor
      },
      // 删除获取对应标签的处理状态
      getDeleteStr(tag) {
        // 获取tbody的下标然后处理数据
        // 获取第一个table标签以前的下标    回去最后一个table标签的下标
        // this.$nextTick(function() {
        const firstcontent = this.editorData.indexOf('<table')
        const endcontent = this.editorData.indexOf('</table>')
        const endndexstarti = this.editorData.lastIndexOf('</table>')
        // 这是全选的操作
        const endALl = this.editorData.indexOf('$' + '{(product_list)!}')
        const precontent = this.editorData.substring(0, firstcontent)
        const endfirst = this.editorData.substring(endcontent + 10)
        const enditem = this.editorData.substring(endndexstarti + 10)
        const startfist = this.editorData.substring(0, firstcontent)
        // this.editorData = ''
        let strth = ''
        let td = ''
        let tdSpan = ''

        this.listItemItem.forEach((element, index) => {
          strth += `<th style='
border: 1px solid #EBEEF6;'>${element.label}</th>`
          if (element['label'] === '编号') {
            td += '<td>${(' + element.key + ')!}</td>'
          } else {
            td += '<td>${(templateProductListVo.' + element.key + ')!}</td>'
          }
        })

        let ItemTitleOne = ''
        if (this.isfutures) {
          // 期货多表格的情况
          let twotempxz = this.getTreeTable(this.showtable)
          this.isFuterData.One = twotempxz.One
          let tdtwo = '',
            strthtwo = ''
          this.isFuterData.item = twotempxz.item
          this.isFuterData.One.forEach((j, k) => {
            strthtwo += `<td class='trr'>${j.label}</td>`
            tdtwo += '<td>${(' + j.key + ')!}</td>'
          })
          ItemTitleOne = `
                 <br/>
                <table cellspacing='0' style='width:100%;
                border:none;
                background:#FFFFFF;
            border: 1px solid #EBEEF6;'>
              <tbody
            <tr style='background-color:#F6F7FA;color:#4E555B;border:none' >
            ${strthtwo}
            ${tdtwo}
              </tr>
            </tbody>
          </table>
            </br>`
        }

        const editdata = `<table datakey class='tb_template_body' cellspacing='0' style='width:100%;border: 1px solid #EBEEF6;'><tbody><tr style='background:#F6F7FA !important;color:#4E555B;font-size:14px !important' class='table-tr'>${strth}</tr>
           <tr>
           ${td}
           </tr>
       </tbody>
       </table>`
        //这是全选的模块
        if (tag) {
          // debugger
          let fistOneIndex = this.editorData.indexOf('</p') + 4, //记录这是第一的index
            findFuters = this.editorData.indexOf('&lt;'),
            findFutersContent = this.editorData.substring(0, findFuters),
            findFutersContents = findFutersContent + '</p>',
            fistOneEnd = this.editorData.indexOf('</table') + 10, //第一个结尾的table
            fistTopContent = this.editorData.substring(0, fistOneIndex), //开头数据-----1
            firstTwoContent = this.editorData.substring(
              this.editorData.lastIndexOf('</table') + 10
            )
          //这是全选状态下的数据
          if (this.isfutures) {
            this.editorData = `${findFutersContents}${firstTwoContent}`
          } else {
            this.editorData = `${startfist}${enditem}`
          }
        } else {
          if (this.isfutures) {
            let fistOneIndex = this.editorData.indexOf('<table'), //记录这是第一的index
              fistOneEnd = this.editorData.indexOf('</table') + 10, //第一个结尾的table
              fistTopContent = this.editorData.substring(0, fistOneIndex), //开头数据-----1
              fistTwoTopContent = this.editorData.substring(
                this.editorData.indexOf('</table') + 10,
                this.editorData.indexOf(
                  '<table',
                  this.editorData.indexOf('</table') + 10
                )
              ),
              temp =
                this.editorData.indexOf(
                  '</table',
                  this.editorData.indexOf(
                    '<table',
                    this.editorData.indexOf(
                      '<table',
                      this.editorData.indexOf('</table') + 10
                    )
                  )
                ) + 10,
              threeTopContentSum = this.editorData.substring(temp),
              threeTopContent = threeTopContentSum.substring(
                0,
                threeTopContentSum.indexOf('<table')
              ),
              fourTopContent = threeTopContent.substring(
                threeTopContent.lastIndexOf('</table') + 10
              )
            this.editorData = `${fistTopContent}${ItemTitleOne}${fistTwoTopContent}${editdata}${threeTopContentSum}`
          } else {
            this.editorData = `${precontent}${editdata}${endfirst}`
          }
        }
        // this.isckedit.setData(this.editorData)
        // ""

        // })
      },
      removehandle(v, i) {
        //判断是不是全部是全部全部清空不是在分别处理函数
        let isdeleteALl = false
        if (v.key === 'whole') {
          isdeleteALl = true
        } else if (v.key === 'sumtotal') {
          //是不是总和
          this.isshowTwoTable = 1
        } else {
          this.isshowTwoTable = 0
        }

        // this.listItemItem.forEach((v,i)=>{
        //   if(v['key']===v['key']){
        //       this.listItemItem.splice(i,1)
        //   }
        // })
        // this.queryParams.type=this.listItemItem

        /**
         * 移除的时候注意首先移除的是不是全部
         * 如果是全部则要将数据清空如果 不是则逐个删除
         *
         * 在在生成的表格信息中删除对应的那一串字符串然后重新添加数据
         *
         */
        if (isdeleteALl) {
          this.listItemItem = []
          this.queryParams.type = []
          this.getDeleteStr(1)
        } else {
          //是不是总和
          if (this.isshowTwoTable) {
            const firstIndex = this.editorData.indexOf('</table>')
            const fistItemcontent = this.editorData.substring(0, firstIndex + 10)
            const endIndex = this.editorData.lastIndexOf('</table>')
            const endcontentItem = this.editorData.substring(endIndex)
            if (this.isfutures) {
              // debugger
              let fist = this.editorData.substring(
                0,
                this.editorData.indexOf('&lt;')
              )
              fist = fist + '</p>'
              let end = this.editorData.substring(
                this.editorData.lastIndexOf('</table') + 10
              )
              this.editorData = `${fist}${end}`
            } else {
              this.editorData = `${fistItemcontent}${endcontentItem}`
            }
          } else {
            // ""
            this.listItemItem.forEach((v1, i) => {
              if (v['key'] === v1['key']) {
                this.listItemItem.splice(v1, 1)
              }
            })
            this.queryParams.type = this.listItemItem
            this.getDeleteStr()
          }
        }
      },
      visableChange(row) {
        this.valueOne = ''
      },
      twovisableChange() {
        this.valueTwo = ''
      },
      threevisableChange() {
        this.valueThree = ''
      },
      toreset() {
        this.editorData = ''
        this.queryParams = {}
      },
      tocancle() {
        this.drawer = false
      },
      handelerouper(row) {
        this.setDataValuehtml('${(' + row + ')!}')
      },

      handlechange(row) {
        this.listItemItem = row

        // ""
        let splcietemp = {}
        // this.queryParams.type = this.listItemS
        this.listItemItem.map((v, i) => {
          if (v.key === 'whole') {
            splcietemp = v
            this.isshowTwoTable = 1
            this.queryParams.type = []
            this.queryParams.type.push(splcietemp)
            this.listItemItem = this.listItemS
          } else if (v.key === 'sumtotal') {
            this.isshowTwoTable = 1
          }
        })
        // ""

        //
      },
      ...FileTemplate,
      getInit(id) {
        this.getTemplateInfo(id).then(res => {
        })
      },
      getTreeTable(type) {
        return SelectwoTableContent(type)
      },
      offerhandler(row) {
        this.isSelected = true
        if (row === 'product_list') {
          const editData = this.editorData
          if(editData.includes('<table cellspacing="0" class="tb_template_body"')){
            this.$message.error('你已经添加过产品列表，请勿重复添加。')
            return
          }
          const tableHeader = `<table cellspacing="0" class="tb_template_body" datakey="" style="width:100%;
              border: 1px solid #EBEEF6;">
<tbody><tr class="table-tr" style="background:#F6F7FA !important;color:#4E555B;font-size:14px !important;
">`
          const aTotalTheader = `<table cellspacing="0" style="width:100%;
border: 1px solid #EBEEF6;background:#FFFFFF;">
<tbody><tr class="sum-1" style="background:#F6F7FA">`
          const allline = '<p class="sumtotals">总计</p>'
          const { listItemItem,isfutures,listItemS } = this
          const prolistData = this.getTreeTable(this.showtable) // 当前模版数据
          const curSelectProData = listItemItem.length ? listItemItem : listItemS
          let futrueHead = ''
          let theader = ''
          let tbody = '<tr>'
          let totaltheader = ''
          let totaltbody = '<tr>'
          let proHTMLStr = ''

          // if(isfutures){
          //   // 期货
          //   futrueHead = "<p class='biaozhi'>${(templateProductListAllVo.expect)!}:${(templateProductListAllVo.futuresProTotal)!}</p>"
          // }
          curSelectProData.forEach(element => {
            if (element.key === 'whole' || element.key === 'sumtotal') return
            theader += `<th class='trr' style='border: 1px solid #EBEEF6;'>${element.label}</th>`
            if (element['label'] === '编号') {
              tbody +=
                '<td style="border: 1px solid #EBEEF6;">${(' +
                element.key +
                ')!}</td>'
            } else {
              tbody +=
                '<td style="border: 1px solid #EBEEF6;">${(templateProductListVo.' +
                element.key +
                ')!}</td>'
            }
          })
          theader += '</tr>'
          tbody += '</tr></tbody></table>'

          prolistData.forEach(items => {
            totaltheader += `<td class='trr' style='border: 1px solid #EBEEF6;'>${items.label}</td>`
            totaltbody +=
              '<td style="border: 1px solid #EBEEF6;">${(' +
              items.key +
              ')!}</td>'
          })
          totaltheader += '</tr>'
          totaltbody += '</tr></tbody></table>'

          proHTMLStr = `${isfutures ? futrueHead: ''}${tableHeader}${theader}${tbody}${allline}${aTotalTheader}${totaltheader}${totaltbody}`
          this.setDataValuehtml(proHTMLStr)
          return
// /***
          // 是否选择了产品列表
          if (this.listItemItem.length > 0) {
            const isfind = this.editorData.indexOf('<table>')
            let slicestr = this.editorData
            if (isfind !== -1 && slicestr.length > 0) {
              slicestr = slicestr.substring(0, isfind)
            }

            let strth = ''
            let td = ''
            let tdss = ''
            const sumtotal = []
            // sumtotal=this.listItemItem;
            // ""
            this.listItemItem.forEach((v, i) => {
              if (v.key !== 'whole' && v.key !== 'sumtotal') {
                sumtotal.push(v)
              }
            })
            //   这是第一期的产品总额
            let futerTwoFirst = ''
            if (this.isfutures) {
              let strthOne = ''
              let tdOne = ''
              const twotemp = this.getTreeTable(this.showtable)
              this.isFuterData.One = twotemp.One
              this.isFuterData.two = twotemp.two
              this.isFuterData.item = twotemp.item
              strthOne += "<td  style=''>${(templateProductListAllVo.expect)!}</td>"
              tdOne += '<td>${(templateProductListAllVo.futureProTotal)!}</td>'

              futerTwoFirst = `
                 <br/>
                <table cellspacing='0' style='width:100%;
                border:none'>
              <tbody
            <tr style='background-color:#F6F7FA;color:#4E555B'>
            ${strthOne}
            ${tdOne}
              </tr>
            </tbody>
          </table>
            </br>`
            }
            sumtotal.forEach(element => {
              strth += `<td class="trr" style='border: 1px solid #EBEEF6;font-size:14px;color:#4E555B' >${element.label}</td>`
              if (element['label'] === '编号') {
                td +=
                  '<td class="uu" style="border: 1px solid #EBEEF6;">${(' +
                  element.key +
                  ')!}</td>'
              } else {
                td +=
                  '<td style="border: 1px solid #EBEEF6;">  ${(templateProductListVo.' +
                  element.key +
                  ')!}</td>'
              }
            })
            const editdata = `<br/><table cellspacing='0' style='width:100%;

            border: 1px solid #EBEEF6;' class='tb_template_body-1'><tbody>
            <tr style='background:#F6F7FA; !important;color:#4E555B;font-size:14px !important' class='table-tr'>${strth}</tr>
           <tr>
           ${td}
           </tr>
           </tbody>
              </table>`
            //这第二期的产品总额

            if (this.isshowTwoTable) {
              const twotemp = this.isfutures
                ? this.isFuterData.item
                : this.getTreeTable(this.showtable)
              let strthtwo = ''
              let tdtwo = ''
              let tds = ''

              twotemp.forEach((j, k) => {
                strthtwo += `<td class="trr" style='border: 1px solid #EBEEF6;font-size:14px;color:#4E555B'>${j.label}</td>`
                tdtwo +=
                  '<td style="border: 1px solid #EBEEF6;font-size:14px;color:#4E555B">${(' +
                  j.key +
                  ')!}</td>'
              })
              // const indextemp = '<td>${templateProductListVo_index}</td>'
              // tdtwo = indextemp + tdtwo
              var contenttwo = `
            <br/>
        <p class='sumtotals'>总计</p>
        <table cellspacing='0'  style='width:100%;
            border: 1px solid #EBEEF6;
            '>
        <tbody>
  <tr style='background:#F6F7FA !important;color:#4E555B;font-size:14px; id='1''>
  ${strthtwo}
  </tr>
  <tr>
   ${tdtwo}
  </tr>
  </tbody>
</table>
</br>`
            }
            // 在这里处理是否直接是
            let replatenewValues = ''
            if (this.isfutures) {
              replatenewValues = `
              <#list item.getTemplateProductListAllVo as templateProductListAllVo>
                ${futerTwoFirst}
                ${editdata}
              <#list item.getTemplateProductListVoList as templateProductListVo>
         ${this.isshowTwoTable ? contenttwo : ''}`
            } else {
              replatenewValues =
                `${editdata}` +
                `
            ${this.isshowTwoTable ? contenttwo : ''}
        `
            }
            // debugger
            this.setDataValuehtml(replatenewValues)
            // this.CKEDITOR_4.innerText('<h1>设置文件</h1>');
          } else {
            // ""
            this.isshowTwoTable = 1
            if (this.editorData.length > 0) {
              const isfind = this.editorData.indexOf('<table>')
              let slicestr = this.editorData

              if (isfind !== -1 && slicestr.length > 0) {
                slicestr = slicestr.substring(0, isfind)
              }

              let strth = ''
              let td = ''
              const temp = []

              // 这里存储着所在的所有的列表但是
              this.listItemS.forEach((v, i) => {
                if (v.key !== 'whole' && v.key !== 'sumtotal') {
                  temp.push(v)
                }
              })
              // ""
              let futerTwoFirst = ''
              if (this.isfutures) {
                let strthOnes = ''
                let twotempxz = this.getTreeTable(this.showtable)
                this.isFuterData.One = twotempxz.One
                this.isFuterData.two = twotempxz.two
                this.isFuterData.item = twotempxz.item
                strthOnes += "<p  style=''>${(templateProductListAllVo.expect)!}:${(templateProductListAllVo.futuresProTotal)!}</p>"

                futerTwoFirst = `
                 <br/>${strthOnes}`
              }

              this.queryParams.type = [...this.listItemS]

              temp.forEach(element => {
                strth += `<th class='trr' style='border: 1px solid #EBEEF6;'>${element.label}</th>`
                if (element['label'] === '编号') {
                  td +=
                    '<td style="border: 1px solid #EBEEF6;">${(' +
                    element.key +
                    ')!}</td>'
                } else {
                  td +=
                    '<td style="border: 1px solid #EBEEF6;">${(templateProductListVo.' +
                    element.key +
                    ')!}</td>'
                }
              })

              const editdata = `<table datakey class='tb_template_body' cellspacing='0' style='width:100%;
              border: 1px solid #EBEEF6;'><tbody>
              <tr style='background:#F6F7FA !important;color:#4E555B;font-size:14px !important;
' class='table-tr' >${strth}</tr>
              <tr>${td}</tr>
              </tbody>
              </table>`

              let contents
              const twotemp = this.isfutures
                ? this.isFuterData.item
                : this.getTreeTable(this.showtable)
              let strthtwo = ''
              let tdtwo = ''
              let tds = ''
              twotemp.forEach((j, k) => {
                strthtwo += `<td class='trr' style='border: 1px solid #EBEEF6;'>${j.label}</td>`
                tdtwo +=
                  '<td style="border: 1px solid #EBEEF6;">${(' +
                  j.key +
                  ')!}</td>'
              })
              contents = `
        <p class='sumtotals'>总计</p>
             <table cellspacing='0'  style='width:100%;
border: 1px solid #EBEEF6;background:#FFFFFF;'>
        <tbody>
        <tr style='background:#F6F7FA' class="sum-1">
  ${strthtwo}
  </tr>
  <tr>
   ${tdtwo}
  </tr>

  </tbody>
</table>
</br>`
              //  上面没有选择
              let not_firstSelect
              if (this.isfutures) {
                not_firstSelect = `
              <#list item.getTemplateProductListAllVo as templateProductListAllVo>
                ${futerTwoFirst}
                ${editdata}
              <#list item.getTemplateProductListVoList as templateProductListVo>
                ${contents}
              `
              } else {
                not_firstSelect = `${editdata}${this.isshowTwoTable ? contents : ''}`
              }
              this.setDataValuehtml(not_firstSelect)
            }
          }
 // ***/
        } else {
          // 说明选择的是别的信息
          // ""
          this.setDataValuehtml('${(' + row + ')!}')

          // if (this.editorData.length > 0) {
          //   this.setDataValuehtml(replateStr(this.editorData, row))
          // } else {
          //   this.editorData = '${(' + row + ')!}'
          // }
        }
        this.getFouce()
      },
      getFouce() {
      },
      handleChangeReplate(row) {
        this.setDataValuehtml('${(' + row + ')!}')
      },
      tosave() {
        // ""
        // if (this.isfutures) {
        //   //  先检查
        //   let isfind = this.editorData.indexOf('#######')

        //   if (isfind != -1) {
        //     let newcontent =
        //       this.editorData.substring(
        //         0,
        //         this.editorData.indexOf('#######') - 3
        //       ) +
        //       '</#list></#list>' +
        //       this.editorData.substring(
        //         this.editorData.lastIndexOf('#######') + 11
        //       )
        //
        //     this.editorData = newcontent
        //   } else {
        //     let newreplate = this.editorData.replace(
        //       new RegExp('<!--#list-->', 'g'),
        //       '</#list>'
        //     )
        //     this.editorData = newreplate
        //   }
        // } else {
        //
        // }

          let iscarry = this.editorData.indexOf(
            '&lt;#list templateProductListAllVoList as templateProductListVo&gt;'
          )
          const isFind = this.editorData.indexOf('<table cellspacing="0"')

          if (isFind !== -1) {
            const firstcontent = this.editorData.substring(
              this.editorData.indexOf('<table cellspacing="0"')
            )
            const offtable = firstcontent.substring(0,
              firstcontent.indexOf('</table') + 10)
            const OneFirstIndex = offtable.indexOf('</tr>')
            const OneFitstcontent = offtable.substring(0, OneFirstIndex + 8)
            const OneEndcontent = offtable.substring(
              offtable.lastIndexOf('<tr'),
              offtable.lastIndexOf('</tr>') + 6
            )

            let firstenx = offtable.substring(
              offtable.lastIndexOf('</tbody>')
            )

            var One = `${OneFitstcontent}<#list templateProductListAllVoList as templateProductListVo>${OneEndcontent}</#list>${firstenx}`
            if (iscarry !== -1) {
              One.replace(
                new RegExp(
                  '<#list templateProductListAllVoList as templateProductListVo><tr>|</#list>|<!--#list-->',
                  'g'
                ),
                ''
              )
            }
            if(this.isfutures){
              One = `${OneFitstcontent}<#list templateProductListAllVo.templateProductListVo as templateProductListVo>${OneEndcontent}</#list>${firstenx}`
            }else{
              One = `${OneFitstcontent}<#list templateProductListAllVoList as templateProductListVo>${OneEndcontent}</#list>${firstenx}`
            }
            const endcontent = this.editorData.substring(
              this.editorData.indexOf('</table') + 10
            )
            var Two = this.editorData.substring(
              this.editorData.indexOf('</table') + 10
            )

            const fisr = this.editorData.substring(
              0,
              this.editorData.indexOf('<table')
            )
            if(this.isfutures){
              const eindex = this.editorData.indexOf('<p class="biaozhi">')
              if(eindex !== -1){
                const hw = this.editorData.substring(0,eindex)
                const fansil = this.editorData.substring(eindex)
                const rindex = fansil.indexOf('</p>')
                if(rindex !== -1){
                  const haofanna =  fansil.substring(rindex + 4)
                  this.editorData = hw + haofanna
                }
              }
              One = "<#list templateProductListAllVo as templateProductListAllVo><p class=\"biaozhi\">${(templateProductListAllVo.expect)!}:${(templateProductListAllVo.futuresProTotal)!}</p>"+One+"</#list>"
            }
            Two = this.editorData.replace(offtable,One)
            this.editorData = Two.replace(new RegExp('</br>', 'g'), '\n')
          }
        let HtmlHeader = `
<html lang="en">
<head>
  <meta charset="UTF-8"/>
  <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
  <title>Document</title>
  <style>
     body{
      font-family: SimHei;
    }
    table{
        border: 1px solid #333;
        border-collapse: collapse;
        width:100%;
    }
    table th,table td{
        padding:5px;
    }
  </style>
</head>
<body>
  ${this.editorData}
</body>
</html>`
        const parmas = {
          createDate: '',
          createIp: 0,
          createUser: '',
          guid: '',
          id: this.templateId,
          lastDate: '',
          lastIp: 0,
          lastUser: '',
          templateContent: HtmlHeader,
          templateName: this.queryParams.templateName
        }
        this.updateInfo(parmas).then(res => {
          // const isflag = true

          this.$message({
            // MessageChannel
            message: res.data.msg,
            type: res.data.code === 200 ? 'success' : 'error'
          })
          this.drawer = false
        })
      },
      onEditorChange({editor, html, text}) {
        this.content = html
      },

      // 加入询价单页面初始化
      onInitial(list, type) {
        this.queryParams.type = []
        //表示当前是非期货的选择   true是期货
        this.isfutures = list.id === 9 ? true : false
        this.showtable = list.id
        this.listItemS = selectSumTemplate(list.id)

        this.queryParams.templateName = list.templateName
        if (!type) {
          this.isdisable = true
          this.isEnd = true
          this.isRandomEnable = new Date().getTime()
          this.editorData = list.templateContent
        } else {
          this.isRandomEnable = 0
          this.isEnd = false
          this.isdisable = false
          this.editorData = list.templateContent

          this.editorData = list.templateContent
            ? list.templateContent.substring(
              list.templateContent.indexOf('<p'),
              list.templateContent.lastIndexOf('</p>') + 6
            )
            : ''
          if (!this.isfutures) {
            this.editorData = this.editorData.replace(
              new RegExp(
                '<#list templateProductListAllVoList as templateProductListVo><tr>|</#list>|<!--#list-->',
                'g'
              ),
              ''
            )
          }else{
            this.editorData = this.editorData.replace(
              new RegExp(
                '<#list templateProductListAllVo as templateProductListAllVo>|</#list>|<!--#list-->',
                'g'
              ),
              ''
            )
            this.editorData = this.editorData.replace(
              new RegExp(
                '<#list templateProductListAllVo.templateProductListVo as templateProductListVo>|</#list>|<!--#list-->',
                'g'
              ),
              ''
            )
          }
        }
        const response = seltOne(list.id)
        console.log('111',response)
        // ""
        this.templateId = list.id
        const {title} = response
        this.placeolder = title.selectTitle
        this.placeolderTwo = title.selectTwoTitle
        this.placeholderThree = title.selectThreeTitle

        if ([1, 2, 5, 7, 8, 9, 4, 3, 6].includes(list.id)) {
          this.isshowThree = true
          this.offerlist = response.group
          this.contractoptions = response.OfferList
          this.supplier = response.quotation
          console.log(response,response.group,response.OfferList,response.quotation)
        } else {
          this.supplier = response.quotation

          // ""

          this.isshowThree = false
          this.contractoptions = response.OfferList
          // ""
        }

        this.drawer = true

        this.getInit(list.id)

      },
      // 查看详情
      onDetails() {
        this.$refs.joinInquirySheetRefs.onInitial(this.proAllContent)
      },
      // 关闭
      onClose() {
        this.drawer = false
      }
    }
  }
</script>
<style lang="less" scoped>
  /deep/ .tb_template_body-1 tr:nth-child(1) {
    background-color: red !important;
  }

  .tbody > tbody > tr:first-child {
    background-color: red !important;
  }

  .tbody {
    background-color: red !important;
  }
</style>
<style lang="less" scoped>
  /deep/ .select_input .el-input__inner {
    background-color: #fff !important;
  }

  /deep/ .el-drawer__body {
    background-color: #ffffff !important;
  }
  /deep/.select_input .el-input--mini .el-input__inner::placeholder{
    color: #484848;
  }
  /deep/.el-select__caret.el-input__icon.el-icon-arrow-up{
    margin-top: 2px;
  }

  .postfix_show {
    margin-left: 9rem;
    position: relative;
    top: -17px;

    font-size: 12px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #83878a;
  }

  /deep/ .cke_wysiwyg_frame .cke_reset {
  }

  /deep/ tr:first-child {
    color: red !important;
  }

  /deep/ .cke_show_borders table.cke_show_border,
  .cke_show_borders table.cke_show_border > tr > td,
  .cke_show_borders table.cke_show_border > tr > th,
  .cke_show_borders table.cke_show_border > tbody > tr > td,
  .cke_show_borders table.cke_show_border > tbody > tr > th,
  .cke_show_borders table.cke_show_border > thead > tr > td,
  .cke_show_borders table.cke_show_border > thead > tr > th,
  .cke_show_borders table.cke_show_border > tfoot > tr > td,
  .cke_show_borders table.cke_show_border > tfoot > tr > th {
    // border:1px solid #
    border: 1px solid #ebeef6 !important;
  }

  // /deep/ .cke_show_border{
  //   width: 100% !important;
  // }
  /deep/ table {
    width: 100% !important;
  }

  // /deep/ cke_contents
  /deep/ .cke_contents {
    height: 400px !important;
  }

  /deep/ .ck.ck-dropdown .ck-button {
    // display:;
    background-color: #e8eaef;
  }

  /deep/ .ck-editor__editable {
    min-height: 800px;
  }

  /deep/
  .ck
  .ck-content
  .ck-editor__editable
  .ck-rounded-corners
  .ck-editor__editable_inline
  .ck-focused {
    outline: none !important;
    border: none !important;
  }

  /deep/
  .ck
  .ck-widget.ck-widget_with-selection-handle:hover
  .ck-widget__selection-handle {
    opacity: 0 !important;
    background-color: none !important;
  }

  /deep/ .ck .ck-widget.ck-widget_selected,
  .ck .ck-widget.ck-widget_selected:hover {
    outline: none !important;
  }

  /deep/ .ck-content .table table th {
    background: none !important;
  }

  /deep/ .ck-content .table table tr:first-child {
    background-color: #f6f7fa !important;
    color: #4e555b;
    font-size: 14px;
  }

  /deep/ .ck-content .table table tr {
    background-color: #ebeef6 !important;
    color: #4e555b !important;
    font-size: 14px;
  }

  /deep/ .ck-content .table table {
    width: 100vw !important;
  }

  /deep/ .ck .ck-widget:hover {
    outline: none !important;
    // display: none !important
  }

  /deep/
  .ck
  .ck-widget.ck-widget_with-selection-handle.ck-widget_selected
  .ck-widget__selection-handle,
  .ck
  .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover
  .ck-widget__selection-handle {
    background: none !important;
    opacity: 0 !important;
  }

  /deep/
  .ck
  .ck-widget.ck-widget_with-selection-handle
  .ck-widget__selection-handle {
    display: none !important;
  }

  /deep/ table {
    outline: none;
  }

  // /deep/
  .parent-node {
    position: relative;
  }

  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #e4e7ed;
    opacity: 0.3;
    z-index: 22;
  }

  .children-filter {
    position: absolute;
    top: 73px;
    right: -124px;
  }

  .not_child-filter {
    position: absolute;
    top: 73px;
    right: 34px;
  }

  .table_filter {
    padding: 10px 0px 10px 30px;
    box-sizing: border-box;
  }

  .title—sum {
    // height: 50px;
    background-color: #fff;
    color: #000000;

    font-size: 18px;
  }

  .footbat {
    display: flex;
    justify-content: flex-end;
    margin-right: 21px;
  }

  // ::v-deep .join-inquier-list-product-title{
  // border-left: 4px ;
  // }
  /deep/ .leftBorder {
    font-size: 18px !important;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold !important;
    color: #4e555b !important;
    // font-size: 14px  !important;
    border-left: 4px solid #276cff !important;
    height: 20px !important;
    padding-left: 10px !important;
    // color: #4E555B  !important;
    margin-bottom: 30px !important;
  }

  h5,
  h4 {
    text-align: center !important;
  }

  h5 {
    margin: 0px !important;
    font-size: 14px;
  }

  .join-inquiry-list-drawer {
    padding: 20px;
    color: #83878a;
    font-size: 14px !important;
    overflow: hidden;

    .join-inquier-list-crumbs {
      padding-left: 20px;
      font-size: 14px;

      span:first-child {
        color: #4e555b;
        padding-right: 10px;
      }
    }

    .join-inquier-list-product {
      padding: 20px;

      .join-inquier-list-product-title {
        font-size: 14px;
        border-left: 2px solid #276cff;
        height: 20px;
        padding-left: 10px;
        color: #4e555b;
        margin-bottom: 30px;
      }
    }

    /deep/ .ql-editor {
      height: 600px;
    }

    .parent_edit {
      position: relative;
      height: 100%;
      // height: 600px;
    }

    .select_item {
      position: absolute;
      top: 8.3%;
      left: 23%;
    }

    .join-inquiry-list-drawer-parameter {
      font-size: 14px;
      margin-top: 20px;
    }

    .join-inquier-list-like-product {
      display: flex;
      justify-content: center;
      align-items: center;

      .el-col-3 {
        div {
          border: 1px solid #e3ecff;
        }
      }
    }
  }

  /deep/ .ql-toolbar.ql-snow {
    background-color: #f5f7fa;
  }

  /deep/ .ql-toolbar.ql-snow .ql-formats {
    // margin-right: 15px;
    margin: 5px;
    padding: 5px;
    box-sizing: border-box;
    background: #e8eaef;
  }

  // /select_input
  /deep/ .select_input .el-input--mini .el-input__inner {
    // background: #e8eaef;
    // padding: 5px;
    height: 32px;
    line-height: 32px;
    box-sizing: border-box;
  }

  .common_font {
    font-size: 14px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #4e555b;
  }

  /deep/ .select_item .el-input__inner::placeholder {
    // color: red;
    .common_font();
    text-align: center;
  }

  /* 谷歌 */
  /deep/ .select_item .el-input__inner::-webkit-input-placeholder {
    .common_font();
    text-align: center;
  }

  /* 火狐 */
  /deep/ .select_item .el-input__inner:-moz-placeholder {
    .common_font();

    text-align: center;
  }

  /*ie*/
  /deep/ .select_item .el-input__inner:-ms-input-placeholder {
    .common_font();

    text-align: center;
  }
</style>
